module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "The Very Beginning"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The Very Beginning ")])])])])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The day I met Julia Child, in June 1971, my last day at Cordon Bleu in London, she toured\n        the school and came to see the results of our final exams. I was brought out to meet her, as\n        I was the only American student in the Advanced Certificate class graduating that day. I had\n        never heard of her, as I had been living in London for a couple of years and had never seen\n        a cooking show on television. In spite of my ignorance, I was drawn to the commanding\n        presence of this woman. Later, on Marylebone Lane in London in front of the Cordon Bleu, I\n        ran into her and asked her what I should do with the rest of my life. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("She answered, “Teach cooking. Open a cooking school. We need cooking schools in America.”\n        I never forgot the advice given to me by this stranger who had only known me five minutes. I\n        had no idea how to teach anything, much less cooking. David, my favorite former husband, and\n        I left London and went to Majorca, where we wound up working in a restaurant—he as\n        bookkeeper, I as chef—without either of us speaking the language or having ever been inside\n        a restaurant kitchen. At the end of the season and a tremendous learning curve, we returned\n        to the United States, to Atlanta, where my father and David’s parents lived. I cooked two\n        carrot cakes a day for a restaurant until it was time to move to fifteen acres of land we\n        had jointly purchased with his stepmother, Celeste Dupree, in rural Georgia, midway between\n        Social Circle and Covington, Georgia, forty miles east of Atlanta, across from the\n        Tri-County Cattle Auction Barn and Hub Junction. ")])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of pots."
    }
  }, [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of pots.",
      "src": "images/_IIP5852.jpg"
    }
  })])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("There, with the help of my brother, we built a kitchen and restaurant inside an old\n        machine shop warehouse we had converted into an antique shop. There was no money for\n        air-conditioning, but then we hadn’t had air-conditioning in Majorca, either. By the next\n        summer, we had put a window unit in the small dining room, and ultimately, one in the\n        kitchen. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("We grew as much of our own food as we could, including exotics like shallots and almost\n        all the summer vegetables for our restaurant. Our neighbors would give us baskets of produce\n        they couldn’t use in exchange for free meals. We also grew an abundance of fresh herbs. To\n        my knowledge, there was no other restaurant in Georgia using fresh herbs at that time\n        except, perhaps, parsley. The majority of upscale restaurants in Atlanta served continental\n        cuisine, while we served what we grew and what we could purchase locally in grocery stores\n        or from local farmers. I did what I had done in Majorca: I combined the fresh produce\n        available with classic European cooking techniques. This ultimately became the basis for\n        what has been called “New Southern Cooking.” It is a continuation of this food that we are\n        doing in this book. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("In the mid-seventies, Rich’s Department Store asked me to start a cooking school in their\n        Downtown Atlanta, Georgia, store. I called Julia and asked if I could come see her. She\n        asked, “What do we have to speak about?” I told her she had suggested start a cooking school\n        when we had met four years earlier. She clearly didn’t remember me. I bumbled on, asking her\n        what kind of a cooking school I should start. “Well, a full participation one, of course,”\n        she said. So I did. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Soon, I was doing what Julia had recommended—teaching. Customers at the restaurant had\n        asked me to teach them, driving down from Atlanta, an hour each way with a few bottles of\n        wine tucked in their cars (our restaurant was in a dry county). I formed friendships with\n        those students that I still have today. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Rich’s Cooking School contained twenty stoves, for a maximum of forty students, in a\n        separate room on the street level of their downtown store. We rarely had that many in a\n        class, unless it was a demonstration class. Within ten years I had taught more than 10,000\n        students and stopped counting. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Julia and her husband, Paul, came to the school many times, promoting her books to large\n        audiences. We grew to know each other, particularly after serving together on the board of\n        the International Association of Culinary Professionals (IACP), our professional\n        organization. She read stories I wrote for "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Brown’s Guide to Georgia")])]), _vm._v("\n        about Southern cooking—classic techniques of biscuit making and fried chicken as well as\n        mainstream recipes from the South. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("On one of her visits we went up to the store’s book department. She purchased some\n            "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Southern Junior League Cookbooks")])]), _vm._v(" as well as one by Mrs. H. R. Dull,\n            "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Southern Cooking.")])]), _vm._v(" Julia said, off-handedly, “Dearie, you should\n        write a book about Southern cooking techniques one day like the articles you are doing.” I\n        felt uneasy, overwhelmed with a “who, me?” feeling and didn’t answer her. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("So, here I am, more than thirty years and twelve books later, with that book she told me\n        to write. She didn’t tell me to use the “Mastering the Art of” part of the name of her book,\n        but out of reverence, I feel I must. It was her idea, after all. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Now I wish we had followed more of her advice. It was given to everyone as part of the\n        introduction to "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Mastering the Art of French Cooking.")])]), _vm._v(" As she said about\n        culling her original manuscript, “even on Bible paper it would take a stand to hold it.” It\n        has taken a lot of winnowing over the last five years to realize what she was saying. We\n        removed 300 pages and a hundred photographs to get it down to 720. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e132",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("She had other advice: “Learn from anyone who knows one thing you don’t know,” and “never\n        apologize.” I have tried to do the learning but have not conquered the “never apologize.”\n        Julia was one of a kind, a master teacher. Women cooks owe her a debt because she forged a\n        path that wouldn’t have existed without her. I hope this book will pay back a little of what\n        she did for me. ")])]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e176",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Why Did We Write This Book? ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e176",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("We dearly love the food of our region and the people who produce and cook it. We fantasize\n        about Southern food, fix it for our families, and tote it to our friends. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e176",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("This book is intended for people who want to know the whys and wherefores of Southern\n        cooking, both historic and modern, and the steps towards achieving great results. It is\n        written for those who have enough time to read the introductory information in the chapters,\n        not the harried cook who simply has to get the food on the table in fifteen minutes for\n        her—or, in these days, his—starving family, although we have some easy recipes, too. It uses\n        almost no pre-packaged ingredients except those necessary in any ")]), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "#/ch03#pantry",
      "title": "The Pantry"
    }
  }, [_vm._v("pantry")]), _vm._v("—canned\n        tomatoes, rice, and a few others—although we have made good use of frozen foods on occasion,\n        particularly those we put up ourselves. Geared towards home cooking as opposed to restaurant\n        fare, it highlights recipes where learning a technique is required, with a bit of thought\n        necessary. The book includes, as well, some recipes and techniques that are easily mastered\n        using local ingredients presented in new ways, such as peaches and figs with country ham. ")]), _c('p', [_vm._v("One of the results of the publication of my book "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("New Southern Cooking")])]), _vm._v("\n        (published in 1985 by Knopf and still in print twenty-seven years later by the University of\n        Georgia Press) was the companion series for Public Television. Cynthia produced over eighty\n        or more television shows in three series. The shows brought an outpouring from Southerners\n        across the United States who wanted to learn to cook foods they remembered eating while\n        growing up. They craved a taste they fondly remembered but didn’t know where to start,\n        because the techniques were no longer in daily practice. Historically, the cooks preparing\n        Southern dishes had made them seem like magic. To them, the needed techniques were part of\n        the rote learning of their childhoods, repeated so much they were second nature. They craved\n        their foods of their region—grits, for instance, used in new and exciting ways as well as\n        traditional. ")]), _c('p', [_c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("New Southern Cooking")])]), _vm._v(" on PBS was groundbreaking. It showed the country\n        how to prepare Southern dishes. Each show featured an entire meal, from starter to dessert.\n        Every step for each dish was shown on camera with no made-up TV magic. When we made a bread,\n        we had a bread made for every stage in a bread’s life, from yeast to slicing. The steps in\n        the process for great Southern recipes like piecrusts, biscuits, and chicken and dumplings\n        were demonstrated in great detail—possible mistakes and all—so the home cook could learn and\n        then duplicate the foods dear to their hearts and memories. Like the book, it codified\n        Southern cooking. ")]), _c('p', [_vm._v("We traveled extensively throughout the Southeast, visiting more than eighty locations to\n        show how our products were grown and produced—catching shrimp, going oystering, picking\n        peaches, making hominy, watching grits being stone ground and peanut butter being made. ")]), _c('p', [_vm._v("A new generation has grown up needing to learn the techniques of how to make biscuits,\n        chicken-fried steak, and hoppin’ John, as well as cream corn, and seed a hot pepper. They\n        see chefs do razzle-dazzle on television but, with a few notable exceptions, not teach the\n        basics. Exotic ingredients flash into recipes, but sadly the basics, such as separating the\n        yolk and white of an egg, are often omitted. We have set out to change this, to codify even\n        further the methodology we used in the television series. We gathered methods and recipes of\n        how to cook the iconic dishes of our region, as well as how to use the available ingredients\n        in more modern ways—such as roasting okra rather than only frying it and yet achieving a\n        crispy, snacking-good result. ")]), _c('p', [_vm._v("Aided by an army of assistants and testers, we culled through recipes to retain the best\n        of the best. We have collected and treasure the historic recipes that form the basis of our\n        cooking, and we feature some of them here to show the silver thread that binds our Southern\n        heritage to the dishes we still serve today. ")]), _c('p', [_vm._v("We couldn’t include them all, so please don’t bemoan the lack of one famous old cake\n        recipe your family always made. It may be on the cutting room floor, and, most likely, the\n        techniques it used are in another recipe. There are hundreds more recipes to be collected\n        and tested. We have focused this book on the basics—the techniques and traditions we feel\n        should be captured, codified, and carried on to the next generation of cooks. There are many\n        more techniques and recipes to be studied and reproduced. We recognize that this new\n        generation will use our book merely as a starting point, adding to it as they gain in skill\n        and experience. ")]), _c('h2', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("What Makes Southern Food Unique? ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Southerners lie awake at night and remember their grandmother’s biscuits, their Aunt Sue’s\n        mashed potatoes and gravy, the grits from the mill down the road, and the boiled peanuts\n        their grandfather taught them to cook in an large, well-used old can over a fire in the\n        backyard. We crave our food and dream about it. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("When we say "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Southerners,")])]), _vm._v(" we don’t mean just the people living here\n        now. We mean all the extended family of Southerners, who write us from Oregon, saying, “My\n        grandmother lived in Mississippi, and she made a hoecake for me every morning for breakfast\n        when I stayed with her in the summer. It was lacy, and crisp, but solid in the middle. She’s\n        gone now, but I sure would like to make that hoecake. Do you know how?” The extended family\n        lives all over the world now, perhaps not even having a relative here anymore. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Their family may have migrated as part of the Southern Diaspora, when African Americans\n        went north or west in search of opportunity and greater freedom but remained segregated,\n        either by choice or design. Both blacks and whites were lured away by the promise of\n        cheaper, more fertile land, education, and advancement—the whites to Kansas before the Civil\n        War or California’s Central Valley during the Great Depression in search of work to feed\n        their families. Or a grandmother had married a soldier, who then moved her to another place\n        from one of the many military bases that at one time dotted the South. But those families\n        passed on the lore, some of them in the manner of African storytellers repeating generations\n        of oral recitations, others through diaries and letters. They reminisced about family and\n        childhood friends. They considered themselves and their children part of the Southern\n        culture no matter how far they roamed. It was and remained part of their identity. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Early English colonists brought cattle, chickens, and pigs as well as curries and spices,\n        wheat, oats, and other grains, along with root vegetables and beans. Africa, through ship\n        captains and others, contributed peas, okra, melons, eggplants, benne (sesame) seeds, and\n        rice. Indigenous foods included the all-important “three sisters”—corn, native beans and\n        squash (including pumpkins)—as well as poke sallet (supplemented by English and African\n        greens), muscadine and other wild grapes, plums, wild game, and seafood. Other arrivals\n        included tomatoes from Central and South America. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Slavery prevailed in areas that depended on large quantities of cheap labor, such as\n        regions growing cotton or rice. Rice, once prevalent in the lower coastal South, had a\n        symbiotic relationship with slavery. Slaves from the rice-growing areas of Africa had the\n        skill, knowledge, and ability to grow the finest rice in the world, bringing great wealth to\n        the South. Hurricanes and the end of slave labor did away with what was left of rice as a\n        primary crop in South Carolina near the end of the nineteenth century, although it is now a\n        boutique crop and continues to be grown there. Louisiana, Arkansas, and Texas continue as\n        rice-growing states into the twenty-first century. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Southern foods vary according to the origins of the inhabitants, as well as the geography,\n        weather, and soil content that range from the Lowcountry of Georgia and South Carolina to\n        the mountains. We include more from some regions than others, to avoid duplication of\n        technique as well as to avoid multiple variations of one recipe. For that reason we offer\n        variations throughout, to hint at the ways others embellish the same recipe. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("There are some decidedly Southern foods that are the buzzwords of what makes our cuisine\n        unique. They include rice, grits, turnip and collard greens with pot likker, okra, pecans,\n        peanuts, hot peppers, black-eyed and other peas. There are more things that make it special,\n        such as our soft-wheat flour and our seafood and the textures of our food. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Corn, a native crop, was historically a crop of much value in the South. Grits, corn meal,\n        and corn flour are integral by-products of corn. Cornbread is as popular as Kentucky whisky,\n        originally called corn moonshine liquor. Corn was eaten freshly boiled and buttered off the\n        cob, scraped to be “creamed” in a frying pan, or fried as fritters. Corn provided sustenance\n        all year. We see it now in even more ways, modern succotash recipes contrasting with\n        microwaved corn on the cob. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("In Texas, only the eastern part remains oriented towards Southern food. West Texas is\n        oriented towards Tex-Mex and Mexican food, as well as beef barbecue. Commercial corn\n        products such as tortillas, along with guacamole and salsas, began finding a place in the\n        Southern diet by the late 1980s, with Mexican and Hispanic foods gaining in the decades that\n        followed. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Florida, too, is only part Southern in its cuisine, primarily the area where Cynthia grew\n        up, near Jacksonville, and farther west into its boundaries with Georgia and Alabama. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Louisiana developed two distinctive cuisines, still independent of other Southern food.\n        The Cajun cuisine, a form of country cooking created by French Acadians, is broad and\n        flavorful. The “holy trinity”—onions, celery, and bell pepper—and “the pope” —garlic—are its\n        base. Creole cuisine is New Orleans city food, a sophisticated, rich mélange of Spanish,\n        French, Italian, and African dishes. In this book, we have not been able to do justice to\n        this noble and exciting food. It is for someone else to do. We have relied on Paul\n        Prudhomme, John Foltz, and the "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Times Picayune")])]), _vm._v(" cookbook for our\n        knowledge, as well as recipes we have collected ourselves. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Hot peppers and their sauces provide an important condiment all over the South. Up until\n        the late eighties, it was common to see simple hot peppers in a jar of vinegar on the table\n        of home kitchens; but now there is an extensive variety of commercial sauces and an\n        astounding infusion of hot peppers of all sizes and heats. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("African foodstuffs brought to the South are still beloved among the broad expanse of\n        Southerners, without regard to color and income. The legacy of poverty suffered by both\n        races after the Civil War, combined with the presence of black cooks (first as slaves then\n        as servants) in white middle-class homes well into the 1960s, resulted in the broader\n        enjoyment of comforting and filling foods that have been called “soul food” for more than\n        forty years. The South remains definitive as a region in which upper-class whites regularly\n        eat peas and other peasant dishes. The peanut is a significant Southern financial and\n        nutritional asset with worldwide dietary influence. Southerners are as liable as other\n        Americans to eat peanut butter sandwiches and salted peanuts. Only in the South, however, do\n        newcomers wonder about “bald peanuts” when hearing native Southerners’ drawl in talking\n        about savoring them. No, they are not hairless; they are freshly harvested peanuts boiled in\n        the shell in salted water. ")])]), _c('p', [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Turnip and collard greens remain an important source of nutrients, and not just among\n        low-income residents. The heat of the kitchen and traditional African one-pot cooking\n        techniques encouraged the slow cooking of tough greens and pole beans on the back of the\n        stove, with a slice of salted or smoked hog jowl, fatback, or streak of lean (seasoning\n        meats to provide flavor and protein) and hot pepper. Young greens are now sautéed, braised,\n        or even used in salads, perhaps rubbed with salt or oil to tenderize and make them\n        malleable, but there is still a great affection at all income levels for the older style,\n        eaten with cornbread, particularly when there is a nip in the air. The broth (called “pot\n        likker”) adds nutritional value and warmth. ")])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e202",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('b')])]), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e239",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The Geography and the Inhabitants ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e239",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The American South is larger than Western Europe. It is composed of the eleven states\n            of the Confederacy, which stretch from Virginia to Texas. The region is bounded on the\n            east by five states bordering the Atlantic Ocean: Virginia, North Carolina, South\n            Carolina, Georgia, and Florida. Four others stretch westward from Florida, on the Gulf\n            of Mexico: Alabama, Mississippi, Louisiana, and Texas. Two other states separated by the\n            Mississippi River—Tennessee and Arkansas—stretch westward from Virginia to Texas. The\n            region also includes the southern parts of the border states to the north that still\n            allowed slavery when the Civil War began, stretching westward from Delaware across\n            Maryland to Kentucky and Missouri. These Border States remained in the Union; West\n            Virginia separated from Virginia over the issue of secession, becoming a new state in\n            1863, yet remains linked to Appalachia. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e239",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The settlers of the region, now home to more than 100 million people, were diverse.\n            Only remnants of Native Americans remained, but large numbers of English, ranging from\n            minor royalty to indentured servants and former prisoners, as well as Africans,\n            Scotch-Irish, French, Spaniards, Germans, and Welch settled early. A smaller cultural\n            sprinkling of Italians, Jews, Chinese, and Greeks, as well as Hispanics (in Texas and\n            later, Florida), added spice to the cultural hodgepodge of food in the South, to form a\n            distinctive blend of Southern cuisine. They are historically linked by the common\n            experience of shared defeat in the American Civil War in the defense of chattel slavery\n            followed by decades of poverty that lasted well into the New Deal. This South is the\n            only region of the United States that from the earliest beginnings was a biracial\n            society. Chicago, Cleveland, Detroit, Los Angeles, New York City, and Washington, D.C.,\n            all have large pockets of Southern cultural infusion. These pockets intertwine and\n            celebrate the food, music, and culture of the South, which expanded there in large part\n            because of the mass migration of several million African Americans (called the Black\n            Diaspora) during and after the post-Civil War period of Reconstruction. It continued to\n            accelerate after World War II until the Civil Rights revolution significantly diminished\n            the region’s history of racial discrimination.")])])])]), _c('h3', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Irresistible Qualities of Southern Foods ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("It is the textures and flavors that are hard to separate by region. Crispy, for instance,\n        is uniquely Southern: crisp fried chicken; crisp fried pork rinds; crisp chitlins; crisp\n        French fries; fried steak; fried catfish and perch, bass and flounder; trout freshly fried\n        from the streams; and even fried watermelon rind. The flavor from lard-fried foods is almost\n        inseparable from the texture of crispy. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Crispy also results from roasting and grilling. The skin of grilled pork crackles when you\n        bite into it. Roasted Sunday chicken, with a skin that separates from the flesh and\n        crunches, leaves the breast moist and tender. Grilled or roasted potatoes become deep brown\n        and crispy around the edges, and just-picked rosemary sprinkled over them takes their flavor\n        over the top. Onions crisp up in the oven, and toasted bread snaps and crackles. Cheese\n        straws offer a crisp introduction before they melt in the mouth. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Flaky-melting is another texture. The combination of lard (or even shortening or butter)\n        and flour in biscuits and piecrusts is unrivaled, due to the Southern flour we have\n        primarily used for over a hundred years, which is lower in gluten and bleached to make it\n        more tender. The melting flakiness of biscuits in one’s mouth cannot be achieved without it. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Tingle on the tongue, the little dancing in our mouth that hot red peppers give,\n        insinuates itself in our foods, from turnip greens to hot pepper jelly. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Which brings us to sweet/sour. In hot pepper jelly, the components of sugar, cider\n        vinegar, and hot peppers form a multipurpose condiment. It adds bite and caramelization to a\n        pork roast (the “ah” taste) or other pig parts, or added to a sautéed piece of country ham\n        is a finishing sauce, melting in the pan and embracing the ham. Vinegar in a cruet, splashed\n        on cooked greens or just about anything brings dash to the daily diet. (Usually the vinegar\n        has a hot pepper immersed in it to give that pop we want.) ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sweetness in main courses—but definitely not in cornbread, which needs no sweetening, corn\n        bringing its own sweetness—is not unusual. Take Coca-Cola with country ham, for instance,\n        either to finish as a reduction in a frying pan or to cook the ham long and slow as it\n        braises. Sweet onions from Vidalia, Georgia, and Texas Sweets smoothly enhance grilled\n        meats, tomatoes, salads, and vegetables, cooked along with, inside, and as an accompaniment,\n        raw or cooked. A little sugar on top of a baked tomato never hurt anyone, nor did brown\n        sugar on a sweet potato. Sweet bourbon beef and Thanksgiving turkey have moved around the\n        country from our sideboards. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Tenderness is another quality. Tender cakes and cobblers, all made from that soft-wheat\n        flour, excel. When I studied cooking in London, my teacher wanted to know what made Southern\n        cakes so much better. It is that combination of tenderness, lightness, and flavor that runs\n        through our desserts and makes them memorable enough to crave when in a different country. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("If a spoon did not stand up in the iced tea from its sugar content, than surely peach\n        cobbler, pralines, divinity, and our cakes—daffodil cake, caramel cake, and coconut cake—and\n        our pies—crispy pecans interspersed with corn syrup giving a crisp-tender rendition, sweet\n        potato pie, fried peach pies with their crisp sweetness, and even peaches eaten over the\n        sink as they drip from our mouths—stand up to anyone’s idea of goodness. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Small wonder our food haunts us when we leave the South, following us wherever we move,\n        emerging more and more in cuisines around the nation and the world, and winding up in the\n        dreams of foreigners. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e245",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("It isn’t just popularity—it’s passion. We love our food! It dominates our thoughts from\n        early morning, when we wonder if we have time for biscuits filled with melting butter, or\n        grits topped with shrimp, and drink our Coca-Cola (Nathalie’s favorite) for breakfast. We\n        think about it through noon, when we have cravings for fried chicken or turnip greens with\n        cornbread. By sundown we wish we had a mint julep—or at least iced tea flavored with freshly\n        picked mint—in our hands, and dream about peach cobbler for dessert. It starts all over\n        again the next morning. ")])])]), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e267",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The Southern Pantry ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e267",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("All of the ingredients in this book can be found in an average Southern local grocery\n        store or market in season. Those of us who can’t live European style and shop every day or\n        two find our pantries invaluable. The modern Southern pantry is a combination of shelves and\n        cupboards, refrigerator and freezer. Some items, like quail, may be special ordered by those\n        who are not so fortunate to have them accessible. ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e267",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Stocking a kitchen is a very individual decision. For busy families, a well-stocked\n        kitchen, featuring most of the items on our lists, will be the quickest answer to the\n        refrain heard every day, “What’s for dinner?” For smaller families, the needs may differ,\n        and relying on flavorful condiments such as our ")]), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch16#conserve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomato Conserve")]), _vm._v(" or a quick "), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch16#pansauce",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan\n        Sauce")]), _vm._v(" made with Dijon mustard and heavy cream to quickly liven-up sautéed chicken\n        breasts or a pork tenderloin are go-to solutions for fast weeknight meals. Singles may cook\n        a main dish leisurely on the weekend and then package it in smaller portions in the freezer\n        for future meals. Still others relish breads and sweets fresh from the oven. They will keep\n        a complete baking pantry. ")])]), _c('p', [_c('b', [_vm._v("We have compiled the lists that follow from our recipes in this book, which represent the\n        cooking we do regularly. We rely heavily on our pantries and spend the bulk of our weekly\n        shopping gathering fresh and seasonal fruits and vegetables for use in our daily meals. ")])]), _c('p', [_c('b', [_vm._v("One caveat: every family should have a list of ten meals they can make with little effort\n        from the pantry (including the refrigerator and freezer). These could include chili, chicken\n        breasts, macaroni pie, rice pilaf, soups, ham and redeye gravy, omelets or other egg\n        preparations, etc. Post the list inside the pantry door for quick reference. The ingredients\n        for these things should be kept on hand at all times, ready for use when the cook is too\n        tired or hungry to think, when the “cook” isn’t home and the other family members need to\n        prepare the meal, or in case of hurricanes and other emergency situations. Replace as you\n        use so your pantry is always complete. ")])]), _c('p', [_c('b', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Nathalie’s top five pantry meals: ")])]), _vm._v("Shrimp and Grits,\n        Sausage and Apples, Macaroni Pie, Fast Chicken Breasts with Ribboned Vegetables, lady peas,\n        and cornbread, Vidalia Onion Tart, Biscuits with Pork Tenderloin. Fortunately salad greens\n        are available year-round in my garden. I keep chicken breasts, sausage, and pork tenderloin\n        in the freezer as part of my pantry staples. There are always bits and pieces for soups\n        there as well. ")])]), _c('p', [_c('b', [_c('span', {
    staticClass: "bold"
  }, [_c('strong', [_vm._v("Cynthia’s top five pantry meals: ")])]), _vm._v("Comforting Cheese Soup\n        (broccoli variation), Lemon-Lime Pot Roast with Tomatoes and Garlic (always a cooked one in\n        her freezer), Skillet Lemon Chicken Thighs (boneless, skinless thighs are a freezer staple\n        for her), along with cooked rice from the freezer, and omelet or savory tart concoctions\n        from the bits and pieces of leftovers on hand. ")])]), _c('p', [_c('b', [_vm._v("Check the expiration dates of canned goods, and keep the oldest ones handiest. If dried\n        herbs are a necessity or preference, since they should be renewed annually, split the\n        purchase with a friend and replenish only as needed. If there is no need to replenish after\n        a year, strike it off the list and do without. Unlike spices, there is rarely a time when\n        one specific herb is the only one that can be used to enhance a dish. Thyme, oregano, and\n        marjoram, are easily interchangeable if not perfect substitutes. If choosing just one, I\n        would choose marjoram. Rosemary lasts well on the pantry shelf, but fresh is better. The\n        ratio of “three to one” commonly used in cookbooks is only applicable if the dried herbs are\n        freshly purchased. Old stale herbs are no better than dust, and there is no ratio for “dust\n        to fresh herbs.” ")])]), _c('h5', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e293",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The Freezer ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e293",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Making double batches of main dishes, having a stash of flavorful stocks, and storing the\n        best of our summer fruits and vegetables is only the tip of the iceberg for how helpful\n        freezer storage can be to the cook. Frozen peaches, mangos, and blueberries are always in\n        Nathalie’s freezer for speedy desserts, along with pecans and peanuts. The boiled peanuts\n        are for her husband. ")])])]), _c('h5', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e297",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cynthia’s Pantry ")])])]), _c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e297",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Being the laziest of cooks, with two children and preferring to spend my time reading old\n        cookbooks, I’ve been known to take shortcuts, especially for hectic weeknight meals. My\n        freezer has bags of frozen chopped onions (as I’m more apt to find a spoiled onion in my\n        pantry than a Vidalia dressed in pantyhose), and my refrigerator has jarred minced garlic.\n        My freezer is never without a bag of sliced peaches, as my favorite last-minute dessert to\n        make for unexpected guests is ")]), _c('span', {
    staticClass: "link",
    attrs: {
      "href": "#/ch14#lazycobbler",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lazy Girl Cobbler")]), _vm._v(", and my self-rising flour gets\n        replenished far more often than my baking soda or baking powder. I almost never cut a recipe\n        down in size: I’ll make the full recipe and freeze some for another meal; it always feels\n        like money in the bank to me. For my weekend cooking, I tend to use all fresh\n        ingredients.")])]), _c('h3', [_c('b', [_c('a', {
    attrs: {
      "id": "pantry",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The Pantry ")])])]), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The Baking Pantry ")])])]), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("All-purpose soft-wheat flour ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Self-rising soft-wheat flour ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Bread flour ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cornmeal ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Self-rising cornmeal mix ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cornstarch ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Baking soda ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Baking powder ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cream of tartar ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Breadcrumbs or panko ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Granulated sugar ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Confectioners’ sugar ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Dark or light brown sugar ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Unflavored gelatin ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Active dry yeast ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Vanilla, lemon, and almond extracts ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Vanilla bean ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Unsweetened cocoa powder ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e306",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Grated or shredded coconut, preferably frozen ")])])])])])]), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Staples in Cans, Jars, Boxes, and Bags on Shelf, in Refrigerator or\n        Freezer ")])])]), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Peas and beans, including black-eyed peas, butter beans, butter peas, cowpeas,\n                crowder peas, English peas, lady peas, and white acre peas preferably frozen but\n                dried or canned if need be ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Tomatoes—crushed, diced and whole, preferably the best brand available ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Tomato paste ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Chicken and beef stock or broth, homemade and commercial ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pecans and peanuts ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Black olives, such as Greek and Italian ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pimentos or jarred red peppers ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Red and white wine vinegar, cider vinegar, sherry vinegar ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Shortening, lard, and/or vegetable oil ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Olive oil ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Soy sauce ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Mayonnaise—preferably Duke’s ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Worcestershire sauce ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Hot sauce ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Horseradish ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ketchup ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Chili sauce ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Tomato conserve ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Coca-Cola ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sorghum, maple syrup, and light or dark corn syrup ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Honey—Tupelo, orange blossom, or sweet clover ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Peanut and other nut butters ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Jams and jellies such as apricot, strawberry, raspberry, red currant, muscadine,\n                and red pepper ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Evaporated and sweetened condensed milk ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Rice—Carolina Gold, long-grain, wild, arborio, on shelf or in freezer ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Quick grits (not instant) and stone-ground grits ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pasta ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Garlic ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Onions ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Potatoes ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Dried fruit—apricots, candied ginger, cherries, cranberries, figs, prunes (dried\n                plums), and raisins ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Graham crackers, gingersnaps, vanilla or chocolate wafers, and/or butter cookies\n                for crusts ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Chocolate, semi-sweet, dark, and milk, in chips or bars ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Bourbon ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Dry sherry and/or dry Madeira, vermouth or other fortified wine ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e366",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Liquor or liqueur, such as Grand Marnier and/or Limoncello, or Cointreau ")])])])])])]), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Refrigerator Staples ")])])]), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Butter, salted and/or unsalted, as preferred ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Large eggs ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Whole milk ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Buttermilk—whole or dried ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Heavy cream ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sour cream ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Clemson blue cheese ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Soft goat cheese ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Parmesan cheese ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sharp Cheddar cheese ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Feta cheese ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Gruyère cheese, preferably Comté, or Swiss in emergencies only ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cream cheese ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Greek or other yogurt ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Fresh herbs in season—thyme, oregano, flat-leaf parsley, basil, marjoram,\n                cilantro, mint, lemon balm, rosemary, chives ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e477",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Meats—pork (streak o’ lean, fatback, or other seasoning meat); country ham\n                slices (thin for biscuits, thicker for sautéing for a meal) ")])])])])])]), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Spices and Seasonings ")])])]), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Benne (sesame) seeds—black and white ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Coriander seed and ground coriander ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Cumin seed and ground cumin ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Fennel seed ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Curry powder ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Chili powder ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ground hot red pepper ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Hot red pepper flakes ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Hungarian paprika ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Mustard—dried and whole seed and Dijon ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ground ginger ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Rosemary ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Ground turmeric ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Whole and ground cloves ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Saffron threads ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Poppy seeds ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Nutmeg ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Whole and ground cinnamon ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Bay leaf ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Salt—kosher, sea, table ")])])])]), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Pepper—black peppercorns, grains of paradise, white or other ")])])])])])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_c('a', {
    attrs: {
      "id": "d0e528",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('b')])])]), _c('h4', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e595",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Season to Taste ")])])])]), _c('p', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e595",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The great gift of cooking is to be in charge of the decisions made in the kitchen.\n            Seasoning a dish is up to the cook, tasting at various points in a recipe, to determine\n            the flavors of the finished dish. In our recipes we use the phrase “season to taste with\n            salt and pepper.” In some recipes, this direction comes at a point in the recipe where\n            physically tasting the dish is impractical. In these cases, we mean to add salt and\n            pepper as you normally would, to the level you appreciate. Where the direction comes\n            later in a recipe, by all means grab a spoon and taste the goodness before deciding how\n            much salt or pepper is needed. The cook is in charge. ")])])])])]), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e595",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('b')])])])]), _c('h4', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e600",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Salt ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e600",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Salt is salt. The basic mineral makeup of salt, no matter where it comes from or how\n            it is packaged, is the same. The differences lie in the physical size and shape of the\n            grains. Table salt is the most common salt used in our recipes. It is always the best\n            for baking, as the grain dissolves well in dough. Kosher salt is a larger grain, and\n            therefore measures differently. The grain takes up more space in the measuring spoon,\n            allowing for more space between grains, and therefore requires a bit more to make up the\n            same measure of table salt. We follow the formula of 1 1/2 teaspoons of Morton brand\n            kosher salt is equal to 1 teaspoon of table salt. For Diamond brand kosher salt, our\n            measure is 2 teaspoons Diamond brand is equal to 1 teaspoon table salt. Sea salt\n            contains additional minerals left behind during the evaporation process, and each\n            measures slightly different, although much more closely to table salt than the kosher\n            salts; so follow the “season to taste” rule.")])])])])])]), _c('h2', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("How to Use this Book ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Any book this size can be intimidating, so begin at the beginning. Reading cookbooks is a\n        pastime enjoyed by many non-cooks, propped up in bed late at night. We only wish it was\n        practiced by more cooks! Resist the temptation to dive right into a recipe in the middle of\n        the book. Take the time to read the information at the beginning of each chapter. The\n        introductory material, both here at the beginning of the book and at the beginning of each\n        chapter, is here for a reason: it introduces the reader to the subject at hand, including an\n        orientation to the ingredients central to the chapter, specific equipment beneficial to the\n        outcome of a recipe, and the techniques needed to achieve success. There is something here\n        for everyone, from the most experienced to the novice. ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Always begin by reading the recipe from start to finish. Visualize the process, gather the\n        ingredients and equipment. Don’t attempt a challenging recipe when you are in a hurry. Give\n        yourself time to work through the details of a recipe. Although the recipes have been\n        written to stand alone, many recipes will give a cross-reference to a technique or another\n        recipe in order to avoid being overly repetitious. Follow the trail through those references\n        to learn more about a technique or process. The index in the back of the book is perhaps the\n        best way to access the detailed information or explanation you might be looking for. ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Some of the recipes are quite long, purposefully. We have written them so that the reader\n        will know what to expect in each stage of the recipe. The language of the recipes is\n        important. In spite of the length of some recipes, all recipes are written in sparse but\n        detailed language. The nuance of the words is important. "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Whisk")])]), _vm._v(" means to\n        use a whisk to combine the ingredients. A stand mixer is called for in a recipe for good\n        reason: the batter is thick, or the mixing time is lengthy; so we call for that specific\n        equipment to make the job easier and the result better. We hope to have written in the voice\n        that gives you confidence, as if we are standing right next to you in the kitchen! ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("But not all of the recipes are challenging. Many will be familiar from Nathalie’s books\n        (the beloved Lazy Girl Cobbler, Snacking Sour Cream Cornbread, Lemon Lime Pot Roast with\n        Tomatoes and Garlic), and others so easy you’ll wonder why you need a recipe. We’ve tried to\n        be thorough but not intimidating. Learning techniques ultimately makes the cook’s job easier\n        and far more rewarding. ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Sprinkled throughout the book are boxes of information that provide a helpful tip, or\n        further elaborate on an ingredient or technique. We’ve also included historical references\n        in these boxes—there’s so much to learn by studying where we’ve come from. ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The foods in these recipes are well known but not old-fashioned. We take the glorious\n        goodness overflowing from our farms and markets, teach a traditional technique, and also use\n        traditional foods in new ways (Okra Chips, anyone?). What’s old is new again, and the\n        techniques are here to enhance your skills and confidence. ")])])])])]), _c('p', [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("The more you cook, the more successful you will be. For the most intimidating of Southern\n        fare, like biscuits and piecrusts, practice is imperative. Give yourself the gift of a quiet\n        morning or afternoon to sequester yourself alone in the kitchen. Make several batches of\n        biscuits, each of different sizes and with different ingredients, to discover which one is\n        your preference and to develop your technique. Do the same with piecrusts. Don’t tell anyone\n        what you are doing. Practicing doesn’t mean perfection, but serving luscious Southern food\n        is about as gratifying as anything I do. A Southern gourmet is one who does the best she/he\n        can with the food at hand. ")])])])])]), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Photo of the recipe or step above."
    }
  }, [_c('b', [_c('b', [_c('b', [_c('a', {
    attrs: {
      "id": "d0e604",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Photo of the recipe or step above.",
      "src": "images/_IIP5484.jpg"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25524e06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch03.vue
// module id = 72
// module chunks = 0